var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('keep-alive',[_c(_vm.activeComponent,{tag:"component",attrs:{"id":_vm.id},on:{"changeComponent":_vm.changeComponent}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }